import type { Country, Resort } from '../model/types';

type ApiBool = boolean | 0 | 1;

export interface ApiCountryResort {
  id: number;
  name: string;
  isPopular?: ApiBool;
  minPrice?: number | null;
}

function toNullableNumber(raw: number | null | undefined): number | null {
  return typeof raw === 'number' && Number.isFinite(raw) ? raw : null;
}

export function adaptCountryResorts(
  data: ApiCountryResort[],
  country: Pick<Country, 'id' | 'name'>,
): Resort[] {
  return data.map((api) => ({
    id: api.id,
    name: api.name,
    countryId: country.id,
    countryName: country.name,
    isPopular: !!api.isPopular,
    minPrice: toNullableNumber(api.minPrice),
  }));
}
